import { atom } from "jotai";

/**
 * Raised by the bulk-signing screen once the signature has actually been scheduled, so the
 * missions list drops its selection mode when the user closes the flow: the contracts it held are
 * on their way to being signed, and the selection no longer means anything. The list resets it as
 * soon as it has reacted.
 */
export const missionsSigningLaunched = atom(false);
